import axios from "axios";

/**
 * Sends one client-side action/error entry to the backend, where it lands in
 * the same ActionLog table backend services write to via ISafeLogger.LogSafe
 * (see WebAPI's PromoterPanelController.LogClientEvent). The same admin log
 * viewer (AdminPanel's ActionLogs screen) shows both sides.
 *
 * Deliberately a separate, un-intercepted axios instance rather than the
 * shared axiosClient — avoids a circular import (axiosClient's own response
 * interceptor calls this to auto-log failures/actions) and avoids the
 * logging call recursively logging itself.
 *
 * Fire-and-forget by design — a logging failure must never surface to the
 * promoter or break whatever action triggered it.
 */
const logClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" },
});

export const logClientEvent = (actionType, description = "", options = {}) => {
  try {
    const { eventId, metadata } = options;
    const token = localStorage.getItem("token");
    logClient
      .post(
        "/PromoterPanel/LogClientEvent",
        { ActionType: actionType, Description: description, EventId: eventId, Metadata: metadata },
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      )
      .catch(() => {});
  } catch {
    // never throw from logging
  }
};
